/** Soft loaders: shared store only, no full-page overlay. */
export const LOADER_SEARCHBOX_SUBMIT = 'searchbox-submit';
export const LOADER_FETCH_SEARCH_RESULTS = 'fetch-search-results';

/** Full-page overlay in <Loader /> — use only via toggleHardPageLoader. */
export const HARD_PAGE_LOADER = 'hard-page-loader';
